export default {
    message: "Les articles listés ci-dessous sont en rupture de stock et ont été supprimés de votre panier. Veuillez faire des sélections différentes.",
    buttons: {
        ok: "D'accord"
    }
}